export function getRequestedPage() {
    return window.location.pathname.split('/').slice(-2)[0];
}

export function getRequestedApplication() {
    return window.location.pathname.split('/')[2];
}